<template>
  <div class="lock-card">
    <div class="lock-card__img">
      <img src="@/assets/images/card-lock.png" />
    </div>
    <div
      class="lock-card__text"
      v-html="$t`Вы собираетесь заблокировать Kaspi Red. <br/> Вы уверены?`"
    ></div>
    <div class="lock-card__actions">
      <ChipButton
        @click="confirmLocking"
        class="lock-card__actions_confirm"
        color="white"
      >
        {{ $t`Заблокировать` }}
      </ChipButton>
      <div class="lock-card__actions_cancel" @click="cancelLocking">
        {{ $t`Отмена` }}
      </div>
    </div>
  </div>
</template>

<script>
import ChipButton from "../shared/button/ChipButton.vue";
export default {
  components: { ChipButton },
  emits: ["confirm", "cancel"],
  methods: {
    confirmLocking() {
      this.$emit("confirm");
    },
    cancelLocking() {
      this.$emit("cancel");
    },
  },
};
</script>

<style lang="scss" scoped>
.lock-card {
  position: relative;
  color: white;
  padding: 78px 15px;
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;

  &__img {
    width: 123px;
    height: 123px;
    margin-bottom: 27px;

    img {
      width: 100%;
      height: 100%;
    }
  }

  &__text {
    text-align: center;
    line-height: 1.2;
    font-size: 24px;
  }

  &__actions {
    font-size: 14px;

    &_confirm {
      margin: 48px 0 20px;
      width: 178px;
    }
  }
}
</style>
